/**
 * CanvasMode - Canvas view embedded in workspace
 * Embeds InteractiveCanvasContainer (which wraps CanvasExplorer with 5-mode tabs)
 */

import type { WorkspaceContext } from '@/stores/workspaceStore'
import { InteractiveCanvasContainer } from '@/components/canvas/interactive'

interface CanvasModeProps {
  context: WorkspaceContext
}

export function CanvasMode({ context }: CanvasModeProps) {
  return (
    <div className="h-full bg-warm-50">
      <InteractiveCanvasContainer />
    </div>
  )
}
